"use client";

// Sheet — the short sheet (a confirm, a picker, a rename, a list of options).
// Since law_sheet_rises (2026-10-08) it is THE sheet, EtherModal, at its small
// size: it rises from the bottom edge, is measured once as it opens and then
// held, owns focus, Esc, the counted scroll lock and the pull-to-dismiss, and
// lets a menu or a studio opened from it stand above it. Callers that hand it a
// `title` get the house head (the title beside the close); `footer` is the one
// action slot, bottom right; `footStart` holds quiet words at the foot's left.
//
//   <Sheet open={renaming} onClose={() => setRenaming(false)} labelledBy={id}
//     title="rename" footer={<PillButton onClick={save}>save</PillButton>}>
//     …the body…
//   </Sheet>
//
// The body is unmounted only once the way down has played (EtherModal keeps it
// for 260ms): a caller whose children read state that `open` turns off must
// keep what it shows until then, or mount the sheet conditionally.

import type { CSSProperties, ReactNode } from "react";
import EtherModal from "../ether/EtherModal";

export default function Sheet({
  open,
  onClose,
  children,
  labelledBy,
  title,
  footer,
  footStart,
  size = "sm",
  height = "fit",
  panelClassName,
  panelStyle,
  backdropClassName,
}: {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  labelledBy?: string;
  /** the sheet's head: what it is, beside the close (rendered as .eth-title with `labelledBy` as its id) */
  title?: ReactNode;
  /** the one action, bottom right */
  footer?: ReactNode;
  /** quiet words at the foot's left */
  footStart?: ReactNode;
  /** sm 520 (the default) · md 680 · lg 820 */
  size?: "sm" | "md" | "lg";
  /** fit: measured once as it opens and held (the default) · tall: one fixed height */
  height?: "fit" | "tall";
  /** a class on the body's wrapper: a caller's own scope for what it lays out inside */
  panelClassName?: string;
  /** inline style on the panel, for publishing a caller's custom properties */
  panelStyle?: CSSProperties;
  /** a class on the sheet's root (was: the backdrop) */
  backdropClassName?: string;
}) {
  return (
    <EtherModal
      open={open}
      onClose={onClose}
      labelledBy={labelledBy}
      size={size}
      height={height}
      className={backdropClassName}
      panelStyle={panelStyle}
      header={
        title != null ? (
          <h2 id={labelledBy} className="eth-title">
            {title}
          </h2>
        ) : undefined
      }
      footer={footer}
      footStart={footStart}
    >
      <div className={panelClassName ? `sheet-body ${panelClassName}` : "sheet-body"}>{children}</div>
    </EtherModal>
  );
}
